import { getFileExtension, isPdfFile } from "@entrilia/shared/utilities/fileHelper";
import type { CitationReference } from "../../../../../api/types/workflowTypes";
import HtmlCitationsPreview from "./HtmlCitationsPreview";
import PdfCitationsPreview from "./PdfCitationsPreview";
import WorkflowFilePreviewHeader from "./WorkflowFilePreviewHeader";

interface Props {
  workflowId: string;
  activityId: string;
  documentName: string;
  citations: CitationReference[];
  selectedCitationId?: string;
  onClose: () => void;
}

const CitationsPreview = ({ workflowId, activityId, documentName, citations, selectedCitationId, onClose }: Props) => {
  return (
    <>
      <WorkflowFilePreviewHeader
        title={documentName}
        fileExtension={getFileExtension(documentName)}
        onClose={onClose}
      />
      {isPdfFile(documentName) ? (
        <PdfCitationsPreview
          workflowId={workflowId}
          documentName={documentName}
          citations={citations}
          selectedCitationId={selectedCitationId}
        />
      ) : (
        <HtmlCitationsPreview
          workflowId={workflowId}
          activityId={activityId}
          documentName={documentName}
          citations={citations}
          selectedCitationId={selectedCitationId}
        />
      )}
    </>
  );
};

export default CitationsPreview;
